export function customAudio() {
    let podcastHolder = $(".podcast-module .item");
    let playButton = podcastHolder.find(".play-button");
    let formatedTime = function (timeToConvert) {
        let hours = Math.floor(timeToConvert / 60 / 60);
        let minutes = Math.floor(timeToConvert / 60) - (hours * 60);
        let seconds = Math.floor(timeToConvert % 60);
        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        return hours + ":" + minutes + ":" + seconds;
    };
    playButton.on("click", function () {
        let $this = $(this);
        let parent = $this.parents(".item");
        let audio = parent.find("audio")[0];
        if ($this.hasClass("active")) {
            $this.removeClass("active");
            audio.pause();
        } else {
            playButton.removeClass("active");
            if (parent.siblings(".item").length) {
                parent.siblings(".item").find("audio")[0].pause();
            }
            $this.addClass("active");
            audio.play();
            audio.addEventListener("timeupdate", function () {
                parent.find(".current-time").text(formatedTime(audio.currentTime));
                let progress = (audio.currentTime / audio.duration) * 100;
                parent.find(".progress-bar .progress").css("width", progress + "%");
                if (audio.currentTime === audio.duration) {
                    $this.removeClass("active");
                    audio.pause();
                    audio.currentTime = 0;
                }
            });
        }
    });
    podcastHolder.each(function () {
        let $this = $(this);
        let audio = $this.find("audio")[0];
        audio.onloadedmetadata = function () {
            $this.find(".podcast-time").text(formatedTime(audio.duration));
        };
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/customAudio.js